module.exports = __webpack_public_path__ + "img/1440.be106c32.jpg";